module.exports = __webpack_public_path__ + "assets/f05268f8ea941d3672b04d62c4dc3d30.svg";